import React, { type ReactNode } from "react";
import Header from "./Header";
import { ThemeProvider } from "./ThemeProvider";

type PageLayoutProps = {
  children: ReactNode;
};

export default function PageLayout({ children }: PageLayoutProps) {
  return (
    <ThemeProvider>
      <div className="site-layout">
        <Header />
        {children}
      </div>
    </ThemeProvider>
  );
}
